function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 56.446,
  cy: 64,
  r: 45.5,
  fill: "#2eb6ea"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.17 109.5c-45.224 0-63.01-59.564-23.164-84.52C28.318 74.617 53.55 75.72 76.99 74.617c39.296-1.793 39.296 34.883 39.296 34.883H56.17z",
  fill: "#1542cd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.464 78.89c-7.032 17.925-24.267 30.058-43.57 30.61h61.218s0-21.51-17.648-30.61z",
  fill: "#745ddf"
}));

function SvgLiquity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquity);
export default __webpack_public_path__ + "static/media/liquity.9ca6cdc3.svg";
export { ForwardRef as ReactComponent };